<template>
    <el-dialog
        title="删除施工单位"
        :visible="dialogVisible"
        width="560px"
        :center="true"
        top="15vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="cancelDelete"
    >
        <!-- 提示文字 -->
        <div class="prompt">请您确认施工单位信息后，再继续执行删除操作：</div>
        <!-- 施工单位 -->
        <div class="dialog-content">施工单位：{{ unitObject ? unitObject.deptName : '-' }}</div>
        <!-- 负责人 -->
        <div class="dialog-content">负责人：{{ unitObject ? unitObject.username : '-' }}</div>
        <!-- 按钮 -->
        <div class="button-div">
            <button @click="cancelDelete" class="cancel">取消</button>
            <button @click="confirmDelete" class="confirm">确定</button>
        </div>
    </el-dialog>
</template>
<script>
import { DeleteUnitList } from '@/http/api/api-hb'
export default {
    data() {
        return {
            dialogVisible: false,
            unitObject: null
        }
    },
    methods: {
        showDeleteUnit(unitObject) {
            console.log(unitObject);
            this.unitObject = unitObject
            this.dialogVisible = true
        },
        cancelDelete() {
            this.dialogVisible = false
        },
        // 确认删除
        confirmDelete() {
            const params = { id: this.unitObject.id }
            DeleteUnitList(params).then(res => {
                if (res.code == 200) {
                    this.cancelDelete()
                    this.$emit('updateUnitList')
                } else {
                    this.$message.warning(res.msg)
                }
            })
        }
    },
}
</script>
<style scoped>
    @import url(../../../assets/css/dialog_button_div.css);
    ::v-deep .el-dialog {
        border-radius: 10px;
    }
    ::v-deep .el-dialog--center .el-dialog__body {
        padding: 0 52px 30px;
        /* background-color: #ff0000; */
    }
    ::v-deep .el-dialog__title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
    }
    /* 文字内容 */
    .prompt {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 25px;
        margin: 24px 0 16px;
    }
    .dialog-content {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
        margin-bottom: 16px;
    }
</style>